<template>
  <div class="session-search-result-container">
    <div class="no-result" v-if="!filteredContactList.length">
      <div>
        <img src="@/assets/no-person.png" alt="" class="no-person">
        <div class="no-result-text">{{$t('home.NoCotacts')}}</div>
      </div>
    </div>
    <div class="has-result" v-else>
      <Contact
        v-if="filteredContactList.length"
        v-slot="{contact}"
        :contactList="filteredContactList"
        :disableCheckboxList="disableCheckboxList"
      >
        <CheckboxLabel :value="contact"></CheckboxLabel>
      </Contact>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Contact from './Contact'
import CheckboxLabel from '@/components/business/session-search-result/CheckboxLabel'
import { CACHE_KEY } from '@/utils/constant'
import { getUnionArray } from './unionArray'
import { clone } from 'ramda'
import { setOnlinerAttrs, onlineToTop } from '@/components/business/contact-company-search/utils'

export default {
  name: 'SessionSearchResult',
  components: {
    Contact,
    CheckboxLabel,
  },
  props: {
    searchVal: {
      type: String,
      default: '',
      required: true
    },
  },
  computed: {
    ...mapGetters(['sortedMembers']),
    ...mapState(['userInfo']),
    ...mapState('collaborator', ['onlineUsers']),
    isPureNums() {
      const regexp = /^[0-9]*$/g
      return regexp.test(this.searchVal)
    },
    filteredContactList() {
      const userList = (this.$ss.get(`${CACHE_KEY.user}_own`) || [])
        .concat(this.$ss.get(`${CACHE_KEY.user}_ext`) || [])

      const searchVal = this.searchVal.toLowerCase()
      function getUserFormNameOrPinyinOrPinyunInit(searchVal){
        function getPingyinInit(nameSpell) {
          return nameSpell?.split('|').map(item => item[0]).join('') ?? ''
        }
        return ({ name, nameSpell }) => (~name.toLowerCase().indexOf(searchVal) ||
        ~nameSpell.replace(/\|/g, '').toLowerCase().indexOf(searchVal) ||
        ~getPingyinInit(nameSpell).toLowerCase().indexOf(searchVal))
      }
      const filterByName = userList.filter(getUserFormNameOrPinyinOrPinyunInit(searchVal)).map(item => (setOnlinerAttrs([...this.onlineUsers.values()], item)))
      let filterByMobile = []
      if (this.isPureNums) {
        filterByMobile = clone(userList.filter(el => ~el.mobile.indexOf(this.searchVal))).map(item => (setOnlinerAttrs([...this.onlineUsers.values()], item)))
        filterByMobile.forEach(el => {
          el.searchType = 'mobile'
        })
      }
      return onlineToTop(getUnionArray(filterByName, filterByMobile))
    },
    disableCheckboxList() {
      const isContainSelf = this.sortedMembers.find(el => el.id === this.userInfo.id)
      const mapId = this.sortedMembers.map(el => el.id)
      return isContainSelf
        ? mapId
        : mapId.concat(this.userInfo.id)
    },
  }
}
</script>

<style scoped lang="less">
.session-search-result-container {
  height: 468px;
  .no-result {
    height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    &>div {
      margin: auto;
      text-align: center;
      .no-person {
        width: 162px;
        height: 114px;
      }
      .no-result-text {
        font-size: 16px;
        font-weight: 400;
        color: #999B9F;
      }
    }
  }
  .has-result {
    width: 100%;
    height: 468px;
    overflow: auto;
  }
}
</style>
